import React, { Component } from 'react';
import { connect } from 'react-redux';
import MensagensPage from './mensagens.page';
import { getUsuarioLocalStorage } from '../../../localStorage.util';
import { bindActionCreators } from 'redux';
import * as commonActions from '../common.action'
import WebapiCommon from '../util/webapi.common';
import IntlMessage from '../../../helpers/intlMessage';

class MensagensContainer extends Component {
    constructor(props) {
        super(props);
        this.ultimoRemetente = null;
        this.ultimaClasse = null;
        this.state = {
            labelHeader: '',
            activeTab: '1',
            sessoes: [],
            mensagens: [],
            usuarios: [],
            cssCollapse: { maxHeight: '0px'},
            destinatario: null,
            laudoSessao: null,
            assuntoSessao: null,
            texto: ''
        }
    }
    
    componentDidMount() {
        var usuario = getUsuarioLocalStorage();
        var requests =[]

        if (this.props.laudoModalMensagens) {
            this.setState({
                laudoSessao: this.props.laudoModalMensagens,
                labelHeader:<IntlMessage id = "dashboards.examDetail.message.report"/>
            });
            requests.push(WebapiCommon.getSessaoDialogoLaudo(this.props.laudoModalMensagens, usuario.usuarioId))
        } else {
            requests.push(WebapiCommon.getSessaoDialogo(usuario.usuarioId))
            this.setState({
                labelHeader: <IntlMessage id = "dashboards.examDetail.message.user"/>
            })
        }

        requests.push(WebapiCommon.getUsuarios())
        Promise.all(requests).then((result) => {
            let usuarios = result[1];
            const index = usuarios.findIndex(x => x.value === usuario.usuarioId);
            usuarios.splice(index, 1);
            let sessoes = [];
            result[0].forEach(element => {
                sessoes.push({...element, ...{ aberta: false}});
            });
            this.setState({
                sessoes,
                usuarios,
                usuarioId: usuario.usuarioId,
            })
        })
    }
    render() {
        return <MensagensPage
            altura={window.innerHeight - 215}
            labelHeader={this.state.labelHeader}
            modalMensagens={this.props.modalMensagens}
            sessoes={this.state.sessoes}
            mensagens={this.state.mensagens}
            cssCollapse={this.state.cssCollapse}
            usuairoId={this.state.usuarioId}
            usuarios={this.state.usuarios}
            destinatario={this.state.destinatario}
            laudoModalMensagens={this.props.laudoModalMensagens}
            texto={this.state.texto}
            gravarTexto={this.gravarTexto.bind(this)}
            enviarMensagem={this.enviarMensagem.bind(this)}
            fechar={this.fechar.bind(this)}
            atualizarDestinoMsg={this.atualizarDestinoMsg.bind(this)}
            abrirConversa={this.abrirConversa.bind(this)}
            checkMensagem={this.checkMensagem.bind(this)}
            getClasseConversa={this.getClasseConversa.bind(this)}
            gravarLaudoSessao={this.gravarLaudoSessao.bind(this)}
            gravarAssuntoSessao={this.gravarAssuntoSessao.bind(this)}
            salvarNovaSessao={this.salvarNovaSessao.bind(this)}
            assuntoSessao={this.state.assuntoSessao}
            laudoSessao={this.state.laudoSessao}
            activeTab={this.state.activeTab}
            exameEntregue={this.props.exameEntregue}
            toggle={this.toggle.bind(this)}
        />
    }

    gravarAssuntoSessao(assunto) {
        this.setState({
            assuntoSessao: assunto,
        });
    }

    gravarLaudoSessao(laudo) {
        this.setState({
            laudoSessao: laudo,
        });
    }
    toggle(activeTab) {
        this.setState({
            activeTab: activeTab
        });
    }

    atualizarDestinoMsg(id) {
        this.setState({
            destinatario: id,
        });
    }

    gravarTexto(texto) {
        this.setState({
            texto,
        });
        this.ultimoRemetente = null;
        this.ultimaClasse = null;
    }
    
    enviarMensagem(sessaoId) {
        WebapiCommon.enviarMensagem(sessaoId, this.state.usuarioId, this.state.destinatario, this.state.texto).then((result) => {
            var sessoes = this.state.sessoes.map((sessao) => {
                if (sessao.id === sessaoId) {
                    sessao.aberta = false;
                }
                return sessao;
            });

            this.setState({
                sessoes,
                texto: '',
            });
            if (this.state.activeTab === '1') this.abrirConversa(sessaoId);
        });
    }

    salvarNovaSessao() {
        WebapiCommon.gravarNovaSessao(this.state.laudoSessao, this.state.assuntoSessao).then((sessaoId) => {
            if (sessaoId > 0) {
                this.enviarMensagem(sessaoId);
                

                this.setState({
                    activeTab: '1',
                    sessoes: [],
                    mensagens: [],
                    usuarios: [],
                    cssCollapse: { maxHeight: '0px'},
                    destinatario: null,
                    laudoSessao: null,
                    assuntoSessao: null,
                    texto: ''
                });

                this.componentDidMount();
            } else {
                this.props.commonActions.showAlerta('alerta', "Este laudo já está finalizado", 2500);
            }

        });
    }
    checkMensagem(id, sessaoId) {
        var mensagem = this.state.mensagens.find((msg) => msg.id === id);

        if (mensagem.lido === 'N') {
            WebapiCommon.checkMensagemLida(this.state.usuarioId, id).then((result) => {
                if (result.sucesso) {
                    var lido = 'S';
                    var usuarioId = this.state.usuarioId;
                    var mensagens = this.state.mensagens.map((msg) => {
                        if(msg.id === id) {
                            msg.lido = 'S'
                        }

                        if(msg.lido === 'N' && msg.destinatarioId === usuarioId) lido = 'N';
                
                        return msg;
                    });

                    var sessoes = this.state.sessoes.map((sessao) => {
                        if (sessao.id === sessaoId) {
                            sessao.mensagens = mensagens;
                            sessao.lido = lido;
                        }
                        return sessao;
                    });
                    
                    this.setState({
                        mensagens,
                        sessoes,
                    });
                    this.props.commonActions.preencherTotalMensagens(this.props.totalMensagens - 1);
                }
            });
        }
    }
    getClasseConversa(mensagem) {
        if (this.ultimoRemetente === null) {
            this.ultimaClasse= 'esquerda';
            this.ultimoRemetente= mensagem.remetenteId;
        } else {
            if (mensagem.remetenteId !== this.ultimoRemetente) {
                this.ultimoRemetente= mensagem.remetenteId;
                this.ultimaClasse= this.ultimaClasse === 'esquerda' ? 'direita' : 'esquerda';
            }
        }
        return this.ultimaClasse;
    }

    abrirConversa(id) {
        var sessao = this.state.sessoes.find((sessao) => sessao.id === id);
    
        if (sessao && !sessao.aberta) {
            WebapiCommon.getMensagensSessao(id).then((result) => {
                this.setState({
                    texto: '',
                    destinatario: null,
                    mensagens: result,
                    cssCollapse: { maxHeight: '600px'}
                });

                var scroll = document.getElementById("conversa");
                scroll.scrollTop = scroll.scrollHeight;
            });

            
        } else {
            this.setState({
                texto: '',
                destinatario: null,
                cssCollapse: { maxHeight: '0px'}
            });
            this.ultimoRemetente= null;
            this.ultimaClasse= null;
        }

        var abrindo = !sessao.aberta;
        var sessoes = this.state.sessoes.map((sessao) => {
            if (abrindo) {
                if(sessao.id === id) {
                    sessao.aberta = true;
                } else {
                    sessao.aberta = false;
                }
            } else {
                if(sessao.id === id) {
                    sessao.aberta = abrindo;
                }
            }
            
            return sessao;
        });

        this.setState({
            sessoes,
        });
    }

    fechar() {
        this.props.commonActions.mudarStatusModalMensagem(false, null)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

const mapStateToProps = (state) => {
    return {
        modalMensagens: state.commonReducer.modalMensagens,
        laudoModalMensagens: state.commonReducer.laudoModalMensagens,
        totalMensagens: state.commonReducer.totalMensagens,
        exameEntregue: state.commonReducer.exameEntregue,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MensagensContainer);


// WEBPACK FOOTER //
// ./src/app/common/mensagens/mensagens.container.js